import { useEffect, useState } from 'react';
import DropMenu from './DropMenu';
import { Link } from 'wouter';
// import Photo from '../../Data/UsersImgs/profilePic';

function Header() {
  // const user = useSelector(selectUser);
  const [show, handleShow] = useState(false);
  // const pic = Photo();
  // const avatar = pic[0];

  const transitionNavBar = () => {
    if (window.scrollY > 10) {
      handleShow(true);
    } else {
      handleShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', transitionNavBar);
    return () => window.removeEventListener('scroll', transitionNavBar);
  }, []);

  return (
    <header className={`${show}`}>
      <div className="flex justify-center mx-5 xl:mx-auto">
        {/* Left */}
        <div
          className="header relative -mx-7 md:-mx-7 lg:-mx-5 my-3 items-center hidden h-20 w-15 
          cursor-pointer md:inline-flex"
        >
          <Link className="text-gray-50 hover:text-red-600" to="/">
            UNDER
          </Link>
          <Link className="text-red-600 hover:text-white" to="/">
            PAGE
          </Link>
        </div>
        <Link to="/">
          <img
            loading="lazy"
            decoding="async"
            className="object-contain relative -mx-4 my-3 items-center 
            shadowPicResponsive h-auto w-24 flex-shrink-0 
            cursor-pointer md:hidden"
            src="https://i.imgur.com/Wcqg4yY.jpg"
            alt="underPage logo"
          />
        </Link>

        {/* Middle - Search input field 
        <div className="max-w-xs hidden lg:inline ">
          <div className="relative rounded-md p-3 mt-24 mx-10 sm:mt-5 md:mt-5">
            <div
              className="cursor-pointer absolute inset-y-0 
          flex items-center pl-3"
            >
              <SearchIcon className="h-5 w-5 text-red-500 hover:text-gray-200" />
            </div>
            <input
              className="block w-full rounded-md border-red-500 bg-transparent 
              pl-10 text-white focus:border-red-600
              focus:ring-red-600 sm:text-sm"
              type="text"
              placeholder="Search in underPage"
            />
          </div>
        </div>*/}

        {/* right */}
        <div className="flex ml-auto items-center justify-end space-x-4 sm:mt-0 md:-mt-1 text-white">
          {/*<Link to="/">
            <HomeIcon className="h-6 w-6 hover:text-red-500 NvBtn relative" />
          </Link>

          <Link to="/profile">
            <UserIcon className="h-6 w-6 hover:text-red-500 NvBtn relative" />
          </Link>

          <button className="text-white NvBtn relative">
            <PaperAirplaneIcon className="h-6 w-6 rotate-45" />
            <div
              className="absolute -top-1 -right-1 text-xs w-4 h-4 bg-red-500 rounded-full 
            flex items-center justify-center animate-pulse"
            >
              14
            </div>
          </button>

          <button className="text-white NvBtn relative">
            <ShoppingCartIcon className="h-6 w-6" />
          </button>

          <button className="relative NvBtn text-white">
            <BellIcon className="h-6 w-6" />
            <div
              className="absolute -top-1 -right-0 text-xs w-2 h-2 bg-red-500 rounded-full 
            flex items-center justify-center animate-ping"
            ></div>
          </button>
          <button className="NvBtn items-center space-x-2">
            <LogoutIcon className="h-6 w-6 hover:text-red-500" onClick={() => auth.signOut()} />
          </button>

        {/* DropDown Menu */}
          <DropMenu />
        </div>
      </div>
    </header>
  );
}

export default Header;
